import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { articleSessionDiagnostics_template } from "../components/templates/articleSessionDiagnostics_template";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

declare var ko: any;
declare var page: any;

export class articleSessionDiagnostics extends vnModule_knockoutJS{

    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected XHRHdl: XMLHttpRequestHandler;
    protected articleSessionDiagnosticsTemplate: articleSessionDiagnostics_template;
    protected firstLoad = true;

    protected getModuleName(){
        return "articleSessionDiagnostics";
    }

    buildContent() : Array<Element>{

        this.articleSessionDiagnosticsTemplate = new articleSessionDiagnostics_template( "articleSessionDiagnostics_template", this.viewModel, this );
        this.template = this.articleSessionDiagnosticsTemplate;

        return [this.articleSessionDiagnosticsTemplate.build()];
    }

    public fillPage() : void{

        // todo uncomment if we decide to keep this report
        /*// First get the presets
        this.getSearchPresetsListData();

        this.articleSessionDiagnosticsTemplate.buildDatePickerCalendar();*/
    }

    public getListFormData(): void{

        this.articleSessionDiagnosticsTemplate.getTemplateViewModel().fetchedReferences(0);
        this.loadingIn(this.articleSessionDiagnosticsTemplate.builtTemplate.children.namedItem("report-filters"));

        let usrReq_url: string = '/api/articleSessionDiagnostics/references/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();

    }

    protected onFilterRequestReturn(req, obj){

        return function(){

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if(  req.request.status == 200  ){
                    obj.articleSessionDiagnosticsTemplate.validationsList.clearMessages();

                    obj.updateFilters(responseParsed);
                    obj.updateViewModelFromPath();

                    obj.articleSessionDiagnosticsTemplate.getTemplateViewModel().fetchedReferences(1);
                    obj.loadingOut(obj.articleSessionDiagnosticsTemplate.builtTemplate.children.namedItem("report-filters"));

                    obj.getGraphData();
                }
                else{
                    obj.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.loadingOut(obj.articleSessionDiagnosticsTemplate.builtTemplate);
            }
        }
    }

    public updateReportData(): void{

    }

    public onDataUpdateRequestReturn(req, obj){

    }

    public getGraphData(): void{

        let subViewModel = this.articleSessionDiagnosticsTemplate.getViewModelForRequest();
        let baseApiUrl;

        if(this.articleSessionDiagnosticsTemplate.getTemplateViewModel().viewModeSelected()=="activeVsBaseline"){

            baseApiUrl = '/api/articleSessionDiagnostics/activeVsBaseline/get/';
            this.loadingIn(this.articleSessionDiagnosticsTemplate.builtTemplate.children.namedItem("content-wrapper").children.namedItem("activeVsBaseline").children.namedItem("graph-results"));
        }
        else if(this.articleSessionDiagnosticsTemplate.getTemplateViewModel().viewModeSelected()=="activeArticleContribution"){

            baseApiUrl = '/api/articleSessionDiagnostics/activeArticleContribution/get/';
            this.loadingIn(this.articleSessionDiagnosticsTemplate.builtTemplate.children.namedItem("content-wrapper").children.namedItem("activeArticleContribution").children.namedItem("graph-results"));
        }
        else{

            baseApiUrl = '/api/articleSessionDiagnostics/failureRateVsSuccessRate/get/';
            this.loadingIn(this.articleSessionDiagnosticsTemplate.builtTemplate.children.namedItem("content-wrapper").children.namedItem("failureRateVsSuccessRate").children.namedItem("graph-results"));
        }

        this.sendFilterCall(baseApiUrl, subViewModel, this.onGraphDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getGraphData');
    }

    protected onGraphDataRequestReturn(req, obj){

        return function(){
            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if(req.request.status == 200) {

                    obj.articleSessionDiagnosticsTemplate.validationsList.clearMessages();
                    obj.updateList(responseParsed);
                }else {

                    obj.onUpdateError(req.request.status, responseParsed);
                }

                if(obj.articleSessionDiagnosticsTemplate.getTemplateViewModel().viewModeSelected()=="activeVsBaseline"){

                    // LOADING : ends
                    obj.loadingOut(obj.articleSessionDiagnosticsTemplate.builtTemplate.children.namedItem("content-wrapper").children.namedItem("activeVsBaseline").children.namedItem("graph-results"));
                }
                else if(obj.articleSessionDiagnosticsTemplate.getTemplateViewModel().viewModeSelected()=="activeArticleContribution") {

                    // LOADING : ends
                    obj.loadingOut(obj.articleSessionDiagnosticsTemplate.builtTemplate.children.namedItem("content-wrapper").children.namedItem("activeArticleContribution").children.namedItem("graph-results"));
                }
                else{

                    // LOADING : ends
                    obj.loadingOut(obj.articleSessionDiagnosticsTemplate.builtTemplate.children.namedItem("content-wrapper").children.namedItem("failureRateVsSuccessRate").children.namedItem("graph-results"));
                }

            }
        }
    }

    public getTopArticlesData(): void{

        this.loadingIn(this.articleSessionDiagnosticsTemplate.builtTemplate.children.namedItem("content-wrapper").children.namedItem("activeVsBaseline").children.namedItem("table-results"));

        let subViewModel = this.articleSessionDiagnosticsTemplate.getViewModelForRequest();
        let baseApiUrl: string = '/api/articleSessionDiagnostics/activeVsBaseline/get/topArticles/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onTopArticlesDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getTopArticlesData');
    }

    protected onTopArticlesDataRequestReturn(req, obj){

        return function(){
            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if(req.request.status == 200) {

                    obj.articleSessionDiagnosticsTemplate.validationsList.clearMessages();
                    obj.updateTableList(responseParsed);
                }else {

                    obj.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.loadingOut(obj.articleSessionDiagnosticsTemplate.builtTemplate.children.namedItem("content-wrapper").children.namedItem("activeVsBaseline").children.namedItem("table-results"));
            }
        }
    }

    public getContributionArticlesData(): void{

        this.loadingIn(this.articleSessionDiagnosticsTemplate.builtTemplate.children.namedItem("content-wrapper").children.namedItem("activeArticleContribution").children.namedItem("table-results"));

        let subViewModel = this.articleSessionDiagnosticsTemplate.getViewModelForRequest();
        let baseApiUrl: string = '/api/articleSessionDiagnostics/activeArticleContribution/get/contributionArticles/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onContributionArticlesDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getContributionArticlesData');
    }

    protected onContributionArticlesDataRequestReturn(req, obj){

        return function(){
            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if(req.request.status == 200) {

                    obj.articleSessionDiagnosticsTemplate.validationsList.clearMessages();
                    obj.updateTableList(responseParsed);
                    obj.updatePagination(responseParsed.totalCount);
                }else {

                    obj.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.loadingOut(obj.articleSessionDiagnosticsTemplate.builtTemplate.children.namedItem("content-wrapper").children.namedItem("activeArticleContribution").children.namedItem("table-results"));
            }
        }
    }

    public getFailureVsSuccessDrillDownData(): void{

        this.loadingIn(this.articleSessionDiagnosticsTemplate.builtTemplate.children.namedItem("content-wrapper").children.namedItem("failureRateVsSuccessRate").children.namedItem("drilldown-graph-results"));

        let subViewModel = this.articleSessionDiagnosticsTemplate.getViewModelForRequest();
        let baseApiUrl: string = '/api/articleSessionDiagnostics/failureRateVsSuccessRate/get/drilldown';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onFailureVsSuccessDrillDownDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getFailureVsSuccessDrillDownData');

    }

    protected onFailureVsSuccessDrillDownDataRequestReturn(req, obj){

        return function(){
            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if(req.request.status == 200) {

                    obj.articleSessionDiagnosticsTemplate.validationsList.clearMessages();
                    obj.articleSessionDiagnosticsTemplate.updateDrillDownFailureRateVsSuccessLinkText();

                    if(obj.articleSessionDiagnosticsTemplate.getTemplateViewModel().idDrillDownMetricFailureVsSuccess() && obj.articleSessionDiagnosticsTemplate.getTemplateViewModel().idDrillDownDimensionFailureVsSuccess()) {
                        obj.articleSessionDiagnosticsTemplate.updateDrillDownFailureRateVsSuccessRateDateGraphData(responseParsed.graphLinesInfo, responseParsed.data, responseParsed.failureCutOffDate);
                    }
                    else {
                        obj.articleSessionDiagnosticsTemplate.updateDrillDownFailureRateVsSuccessRateDateGraphNoData();
                    }
                }else {

                    obj.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.loadingOut(obj.articleSessionDiagnosticsTemplate.builtTemplate.children.namedItem("content-wrapper").children.namedItem("failureRateVsSuccessRate").children.namedItem("drilldown-graph-results"));
            }
        }
    }

    protected updateFilters(responseParsed: any) {

        this.articleSessionDiagnosticsTemplate.setBrandsFilterItems(responseParsed.departments);
        this.articleSessionDiagnosticsTemplate.setInitiativesFilterItems(responseParsed.initiatives);
        this.articleSessionDiagnosticsTemplate.setIntentsFilterItems(responseParsed.intents);
        this.articleSessionDiagnosticsTemplate.setContentTypesFilterItems(responseParsed.contentTypes);
    }

    protected updatePagination(totalCount) {

        this.articleSessionDiagnosticsTemplate.updatePagination(totalCount);
    }

    protected updateList(responseParsed: any) {

        this.articleSessionDiagnosticsTemplate.resetData();

        if (this.articleSessionDiagnosticsTemplate.getTemplateViewModel().viewModeSelected() == "activeVsBaseline") {

            if (this.firstLoad){

            }

            this.articleSessionDiagnosticsTemplate.updateActiveVsBaselineDateGraphData(responseParsed.graphLinesInfo,responseParsed.data);
            this.updateTableDataOnFilterChange();
        }
        else if (this.articleSessionDiagnosticsTemplate.getTemplateViewModel().viewModeSelected() == "activeArticleContribution") {

            this.articleSessionDiagnosticsTemplate.updateActiveArticleContributionDateGraphData(responseParsed.graphLinesInfo,responseParsed.data);
            this.updateTableDataOnFilterChange();
        }
        else {

            this.articleSessionDiagnosticsTemplate.updateFailureRateVsSuccessRateDateGraphData(responseParsed.graphLinesInfo, responseParsed.data, responseParsed.failureCutOffDate);
            this.getFailureVsSuccessDrillDownData();
        }

        this.firstLoad = false;
    }

    protected updateTableList(responseParsed: any) {

        this.articleSessionDiagnosticsTemplate.resetData();

        if (this.articleSessionDiagnosticsTemplate.getTemplateViewModel().viewModeSelected() == "activeVsBaseline"){

            if (this.firstLoad){

            }

            this.articleSessionDiagnosticsTemplate.updateActiveVsBaselineTableData(responseParsed.data);

        }
        else if (this.articleSessionDiagnosticsTemplate.getTemplateViewModel().viewModeSelected() == "activeArticleContribution") {

            if (this.firstLoad){

            }

            this.articleSessionDiagnosticsTemplate.updateContributionArticlesTableData(responseParsed.data);
            this.articleSessionDiagnosticsTemplate.addContributionArticlesTrendGraphs(responseParsed.contributionArticleSessionsTrend);

        }else {

        }

        this.firstLoad = false;
    }

    protected onUpdateError(requestStatus: any, responseParsed) : void{

        let msg = "error: while retrieving the data";
        this.articleSessionDiagnosticsTemplate.validationsList.setSingleMessage({field: "error", "label": "code " + requestStatus, message: responseParsed.message});
        window.scrollTo(0, 0);
    }

    protected filterMultipleSelectorOnChange() {

        this.getGraphData();
    }

    protected filterDateOnChange() {

        this.getGraphData();
    }

    protected filterSimpleOnChange() {

        this.getGraphData();
    }

    protected filterDropdownOnChange(){

        this.getGraphData();
    }

    protected paginationOnPageClick(){

        if(this.articleSessionDiagnosticsTemplate.getTemplateViewModel().viewModeSelected()=="activeVsBaseline"){


        }
        else if(this.articleSessionDiagnosticsTemplate.getTemplateViewModel().viewModeSelected()=="activeArticleContribution") {

            this.getContributionArticlesData();
        }
        else{

        }
    }

    public listReorder(){

        if (this.articleSessionDiagnosticsTemplate.getTemplateViewModel().viewModeSelected() == "activeVsBaseline") {

            this.getTopArticlesData();
        }
        else if (this.articleSessionDiagnosticsTemplate.getTemplateViewModel().viewModeSelected() == "activeArticleContribution") {

            this.getContributionArticlesData();
        }
        else {

        }
    }

    protected updateTableDataOnFilterChange() {

        if (this.articleSessionDiagnosticsTemplate.getTemplateViewModel().viewModeSelected() == "activeVsBaseline") {

            let dateIsset = this.articleSessionDiagnosticsTemplate.getTemplateViewModel().topArticlesDate() != "";
            let isBetweenDates = this.articleSessionDiagnosticsTemplate.getTemplateViewModel().datesFilter.startDate() <= this.articleSessionDiagnosticsTemplate.getTemplateViewModel().topArticlesDate() && this.articleSessionDiagnosticsTemplate.getTemplateViewModel().datesFilter.endDate() >= this.articleSessionDiagnosticsTemplate.getTemplateViewModel().topArticlesDate();

            if (dateIsset && isBetweenDates) {
                this.articleSessionDiagnosticsTemplate.getTemplateViewModel().topArticlesData([]);
                this.getTopArticlesData();
            } else {
                this.articleSessionDiagnosticsTemplate.getTemplateViewModel().topArticlesDate("")
                this.articleSessionDiagnosticsTemplate.getTemplateViewModel().topArticlesData([]);
            }
        }
        else if (this.articleSessionDiagnosticsTemplate.getTemplateViewModel().viewModeSelected() == "activeArticleContribution") {

            let dateIsset = this.articleSessionDiagnosticsTemplate.getTemplateViewModel().contributionArticlesDate() != "";
            let isBetweenDates = this.articleSessionDiagnosticsTemplate.getTemplateViewModel().datesFilter.startDate() <= this.articleSessionDiagnosticsTemplate.getTemplateViewModel().contributionArticlesDate() && this.articleSessionDiagnosticsTemplate.getTemplateViewModel().datesFilter.endDate() >= this.articleSessionDiagnosticsTemplate.getTemplateViewModel().contributionArticlesDate();

            if (dateIsset && isBetweenDates) {
                this.articleSessionDiagnosticsTemplate.getTemplateViewModel().contributionArticlesData([]);
                this.getContributionArticlesData();
            } else {
                this.articleSessionDiagnosticsTemplate.getTemplateViewModel().contributionArticlesDate("")
                this.articleSessionDiagnosticsTemplate.getTemplateViewModel().contributionArticlesData([]);
            }
        }
        else {

        }

    }

    public getExportData(): void{

        if (this.articleSessionDiagnosticsTemplate.getTemplateViewModel().viewModeSelected() == "activeVsBaseline") {

            this.loadingIn(this.articleSessionDiagnosticsTemplate.builtTemplate.children.namedItem("content-wrapper").children.namedItem("activeVsBaseline").children.namedItem("table-results"));

            this.XHRHdl.cancelAndReset();

            let subViewModel = this.articleSessionDiagnosticsTemplate.getViewModelForRequest();

            let usrReq_url: string = '/api/articleSessionDiagnostics/activeVsBaseline/get/topArticles/export/';
            let usrReq_params: Array<Array<string>> = [];
            usrReq_params.push(["data", ko.toJSON(subViewModel)] );
            this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

            this.XHRHdl.onReadyStateFunction = this.onGetExportData;
            this.XHRHdl.execute();
        }
        else if (this.articleSessionDiagnosticsTemplate.getTemplateViewModel().viewModeSelected() == "activeArticleContribution") {

            this.loadingIn(this.articleSessionDiagnosticsTemplate.builtTemplate.children.namedItem("content-wrapper").children.namedItem("activeArticleContribution").children.namedItem("table-results"));

            this.XHRHdl.cancelAndReset();

            let subViewModel = this.articleSessionDiagnosticsTemplate.getViewModelForRequest();

            let usrReq_url: string = '/api/articleSessionDiagnostics/activeArticleContribution/get/contributionArticles/export/';
            let usrReq_params: Array<Array<string>> = [];
            usrReq_params.push(["data", ko.toJSON(subViewModel)] );
            this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

            this.XHRHdl.onReadyStateFunction = this.onGetExportData;
            this.XHRHdl.execute();
        }
        else {

        }

    }

    protected onGetExportData(req, obj){

        return function () {

            if(obj.articleSessionDiagnosticsTemplate.getTemplateViewModel().viewModeSelected()=="activeVsBaseline"){

                obj.manageResponse(req, obj, function () {

                    let responseParsed = JSON.parse(req.request.response);
                    if (req.request.status == 200) {

                        obj.articleSessionDiagnosticsTemplate.validationsList.clearMessages();
                        obj.articleSessionDiagnosticsTemplate.setExportData(responseParsed.data);
                        obj.articleSessionDiagnosticsTemplate.exportData();
                    }
                });

                obj.loadingOut(obj.articleSessionDiagnosticsTemplate.builtTemplate.children.namedItem("content-wrapper").children.namedItem("activeVsBaseline").children.namedItem("table-results"));
            }
            else if(obj.articleSessionDiagnosticsTemplate.getTemplateViewModel().viewModeSelected()=="activeArticleContribution") {

                obj.manageResponse(req, obj, function () {

                    let responseParsed = JSON.parse(req.request.response);
                    if (req.request.status == 200) {

                        obj.articleSessionDiagnosticsTemplate.validationsList.clearMessages();
                        obj.articleSessionDiagnosticsTemplate.setExportData(responseParsed.data);
                        obj.articleSessionDiagnosticsTemplate.exportData();
                    }
                });

                obj.loadingOut(obj.articleSessionDiagnosticsTemplate.builtTemplate.children.namedItem("content-wrapper").children.namedItem("activeArticleContribution").children.namedItem("table-results"));
            }
            else{

            }


        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/articleSessionDiagnostics.ts